import axios from "axios";
// import router from '../routerManuaConfig'
import store from "../store";
import Vue from "vue";
import { refreshToken, saveRefreshtime, ToLogin } from "../api/auth";
// 如果是IIS部署，用这个，因为 IIS 只能是 CORS 跨域，不能代理
// let base = process.env.NODE_ENV=="production"? 'http://localhost:8081':'';
const service = axios.create({
	baseURL: "https://tc.mtfpos.com", // url = base url + request url
	// withCredentials: true, // send cookies when cross-domain requests
	timeout: 60000, // request timeout
});
var storeTemp = store;
let loading;
function startLoading() {
	loading = Vue.prototype.$loading({
		background: "rgba(0, 0, 0, 0)",
		lock: true,
		fullscreen: false,
	});
}
function endLoading() {
	needLoadingRequestCount = 0;
	loading.close();
}
//声明一个对象用于存储请求个数
let needLoadingRequestCount = 0;
function showFullScreenLoading() {
	if (needLoadingRequestCount === 0) {
		startLoading();
	}
	needLoadingRequestCount++;
}
function tryHideFullScreenLoading() {
	needLoadingRequestCount--;
	if (needLoadingRequestCount === 0) {
		endLoading();
	}
}
service.interceptors.request.use(
	(config) => {
		showFullScreenLoading();
		var curTime = new Date();
		var expiretime = new Date(Date.parse(storeTemp.state.tokenExpire));
		if (
			storeTemp.state.token &&
			(curTime < expiretime && storeTemp.state.tokenExpire)
		) {
			// 判断是否存在token，如果存在的话，则每个http header都加上token
			config.headers.Authorization = "Bearer " + storeTemp.state.token;
		}
		saveRefreshtime();
		return config;
	},
	(err) => {
		return Promise.reject(err);
	}
);
// http response 拦截器
service.interceptors.response.use(
	(response) => {
		endLoading();
		if (!response.data.success) {
			Vue.prototype.$message({
				message: response.data.msg,
				type: "error",
			});
			return Promise.reject(new Error(res.message || "Error"));
		}
		return response.data.response;
	},
	(error) => {
		let errInfo = { success: false, message: "错误" };
		// 超时请求处理
		var originalRequest = error.config;
		if (
			error.code == "ECONNABORTED" &&
			error.message.indexOf("timeout") != -1 &&
			!originalRequest._retry
		) {
			errInfo.message = "请求超时！";
			originalRequest._retry = true;
		} else if (error.response) {
			if (error.response.status == 401) {
				var curTime = new Date();
				var refreshtime = new Date(Date.parse(window.localStorage.refreshtime));
				// 在用户操作的活跃期内
				if (window.localStorage.refreshtime && curTime <= refreshtime) {
					return refreshToken({ token: window.localStorage.Token }).then(
						(res) => {
							if (res.success) {
								store.commit("saveToken", res.token);
								var curTime = new Date();
								var expiredate = new Date(
									curTime.setSeconds(curTime.getSeconds() + res.expires_in)
								);
								store.commit("saveTokenExpire", expiredate);
								error.config.__isRetryRequest = true;
								error.config.headers.Authorization = "Bearer " + res.token;
								endLoading();
								return service(error.config);
							} else {
								// 刷新token失败 清除token信息并跳转到登录页面
								endLoading();
								ToLogin();
								Vue.prototype.$message({
									message: "登录状态已过期，请重新登录！",
									type: "error",
								});
								return Promise.reject(
									new Error("登录状态已过期，请重新登录！")
								);
							}
						}
					);
				} else {
					// 返回 401，并且不知用户操作活跃期内 清除token信息并跳转到登录页面
					endLoading();
					ToLogin();
					Vue.prototype.$message({
						message: "登录状态已过期，请重新登录！",
						type: "error",
					});
					return Promise.reject(new Error("登录状态已过期，请重新登录！"));
				}
			} else if (error.response.status == 400) {
				errInfo.message = "失败！提交的数据参数异常!";
			}
			// 403 无权限
			else if (error.response.status == 403) {
				errInfo.message = "失败！该操作无权限";
			}
			// 429 ip限流
			else if (error.response.status == 429) {
				errInfo.message = "刷新次数过多，请稍事休息重试！";
			} else if (error.response.status == 404) {
				// 404 不存在
				errInfo.message = "失败！访问接口不存在";
			} else if (error.response.status == 500) {
				// 500 服务器异常
				errInfo.message = "失败！服务器异常";
			} else if (error.response.status == 405) {
				// 405 请求http方法错误
				errInfo.message = "失败！请求http方法错误";
			} else if (error.response.status == 415) {
				// 415 参数没有指定Body还是Query
				errInfo.message = "失败！参数没有指定Body还是Query";
			} else {
				//其他错误参数
				errInfo.message = "失败！请求错误" + error.response.status;
			}
		} else {
			errInfo.message = "失败！服务器断开";
		}
		endLoading();
		Vue.prototype.$message({
			message: errInfo.message,
			type: "error",
		});
		return Promise.reject(new Error(res.message || "Error"));
		//return errInfo; // 返回接口返回的错误信息
	}
);
export default service;
